import "../i18n";
import React, { useEffect, useState } from 'react';
import { Sentry } from "../sentryInstrumentReact";

import ProcessingSpinner from './ProcessingSpinner';


function PodcastList({ language }) {
  const [podcasts, setPodcasts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(null);


  useEffect(() => {

    async function fetchPodcast() {
      
      setIsLoading(true);
      try {
        let fetchURL = '';
        if (language === "pt") {
          fetchURL = "https://www.avivanossoscoracoes.com/podcast/_api/podcastsapi/";
        } else if (language === "es") {
          fetchURL = "https://www.avivanuestroscorazones.com/podcast/_api/podcastsapi/";
        } else if (language === "fa") {
          fetchURL = "https://new.delhayemanehiakon.org/podcast/_api/podcastsapi/";
        } else if (language === "fr") {
          fetchURL = "https://www.reveillenoscoeurs.com/podcast/_api/podcastsapi/";
        } else if (language === "en") {
          fetchURL = "https://www.reviveourhearts.com/podcast/_api/podcastsapi/";
        }

        let response = await fetch(fetchURL);
        let data = await response.json();
        setPodcasts(data.results);
        
      } catch(error) {

        Sentry.captureException(error, {stage: "podcast listing"});

      }
      setIsLoading(false);

    }

    fetchPodcast();
  }, [language]);

  function formatHosts(hostsArray) {
    if (hostsArray.length > 1) {
      const hostsCopy = [...hostsArray];
      const lastHost = hostsCopy.pop();
      const formattedHosts = hostsCopy.join(", ") + " and " + lastHost;
      return formattedHosts; 
    } else if (hostsArray.length === 1) {
      return hostsArray[0];
    } else {
      return " "; 
    }
  }

  const handlOpenModal = (event, index) => {
    event.preventDefault();
    setOpenModal(index);
  }

  const handleCloseModal = () => {
    setOpenModal(null);
  }

  return (
    <ul className="podcast-squares" style={{marginTop: ".5rem"}}>
      {isLoading ? (
        <ProcessingSpinner />
      ) : (
        <>
          {podcasts.map((podcast, index) => (
            <>
              <li style={{maxWidth: "242px"}} key={index}>
                <div className="podcast-square-inner">
                  <a href="#" className="info modalButton" title={window.gettext("Click to see more information.")} onClick={(event) => handlOpenModal(event, index)} tabIndex="-1">
                    <svg className="icon" width="16" height="16"><use href="#expand"></use></svg>
                  </a>
                  <a href={podcast.web_url} title={window.gettext("Listen Now")}>
                    <picture>
                      <source srcset={podcast.graphics.webp_thumbnail} type="image/webp" />
                      <img loading="lazy" width="242" height="242" src={podcast.graphics.thumbnail} alt={`${podcast.title} cover image`} />
                    </picture>
                  </a>
                </div>
                <dialog className="dialog" aria-hidden={openModal !== index} open={openModal === index}>
                  <button className="close-modal" aria-label="close" onClick={handleCloseModal}>✕</button>
                  <div className="modal-content modal-content--podcast-info">
                    <div className="podcast-branding">
                      <a href={ podcast.web_url } title={window.gettext("Listen Now")}>
                        <picture>
                          <source srcset={podcast.graphics.webp_thumbnail} type="image/webp" />
                          <img loading="lazy" src={podcast.graphics.thumbnail} alt={`${podcast.title} cover image`} />
                        </picture>
                      </a>
                      <div><a href={podcast.web_url} className="btn btn-sm btn-primary">{window.gettext("Listen Now")}</a></div>
                    </div>
                    <div className={language == "fa" ? "podcast-description rtl" : "podcast-description"}>
                      <h2>{podcast.title}</h2>
                      <p className="hosts">{formatHosts(podcast.hosts)}</p>
                      <p dangerouslySetInnerHTML={{__html: podcast.description}}></p>
                    </div>
                  </div>
                </dialog>
              </li>
            </>
          ))}
        </>
      )}
    </ul>
  )
}

export default PodcastList;
